import clsx from "clsx"
import React from "react"

import { tagClasses } from "./style"
import { createTagLabel } from "./TagLabel"
import type { TagProps } from "./types"
import { Label } from "../../Typography/Label/Label.react"

const TagLabel = createTagLabel(Label)

/**
 * **Props**:
 * - `text`: string
 * - `size`: "large" | "small"
 * - `bgColor`: "neutral" | "primary" | "lilac" | "green" | "red" | "yellow" | "orange" | "lightGrey"
 *
 * See also: {@link TagProps}
 */
export const Tag = ({ size = "large", text, bgColor, className, testId, style: _style, icon }: TagProps) => {
  return (
    <div data-testid={testId} className={tagClasses({ size, bgColor, className })}>
      <span>
        {icon &&
          React.cloneElement(icon, {
            ...icon.props,
            height: size == "large" ? 16 : 12,
            width: size == "large" ? 16 : 12,
            className: clsx(icon.props.className, "mr-0.5"),
          })}
      </span>
      <TagLabel size={size} bgColor={bgColor} text={text} />
    </div>
  )
}
